import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class PrevOpenedTaskService {
  public prevOpenedTaskId: number | null = null;
  public setPrevOpenedTaskId(taskId: number | null): void {
    this.prevOpenedTaskId = taskId;
  }
}
